import { render, staticRenderFns } from "./cta_menu.vue?vue&type=template&id=2418b9b5&scoped=true&"
import script from "./cta_menu.vue?vue&type=script&lang=js&"
export * from "./cta_menu.vue?vue&type=script&lang=js&"
import style0 from "./cta_menu.vue?vue&type=style&index=0&id=2418b9b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418b9b5",
  null
  
)

export default component.exports